// src/pages/products/EditProduct.jsx

import React from "react";
import { useParams, useNavigate } from "react-router-dom";

import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditProduct from "../../components/products/FormAddEditProduct";
import useGetProduct from "../../hooks/products/useGetProduct";
import LoadingPage from "../../components/global/LoadingPage";

const EditProduct = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, product } = useGetProduct(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/products");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditProduct
                isEdit={true}
                currentData={product}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditProduct;
